import { formatTimer } from "./timer";

/**
 * Remove a target object from array
 * @param {array} array
 * @param {object} target
 */

const deleteElement = (array, target) => {
  return array.filter(item => {
    return item != target;
  });
};

/**
 * Insert initial songs params
 * @param {array} songs
 */

const threatSongs = songs => {
  return songs.map(song => {
    song["isPlaying"] = false;
    song["percent"] = 0;
    song["currentlyTimer"] = "00:00";
    song["totalTimer"] = formatTimer(song.seconds);

    return song;
  });
};

export { deleteElement, threatSongs};
